// @flow

export const APP_STATUSES = Object.freeze({
  private: {
    name: 'private',
    display: 'Private',
    lifecycle: 'build',
    published: false,
  },
  pending: {
    name: 'pending',
    display: 'Pending',
    lifecycle: 'review',
    published: false,
  },
  beta: {
    name: 'beta',
    display: 'Public',
    lifecycle: 'beta',
    published: true,
  },
  public: {
    name: 'public',
    display: 'Public',
    lifecycle: 'partnered',
    published: true,
  },
});
export const INVITE_STATUSES = { accepted: 'accepted' };
export const APP_STATUS_INVITE_ONLY = {
  name: 'inviteOnly',
  display: 'Invite-Only',
  published: false,
};
export const DEPLOYMENT_STATUSES = Object.freeze({
  production: 'production',
  private: 'non-production',
  deprecated: 'deprecated',
});
export const VERSION_STATUSES = Object.freeze({
  deprecated: 'deprecated',
  private: 'private',
  public: 'public',
});
